<div class="list-wrapper">
  <div *ngIf="group">
  <form-control-model
    [defaultHeight]="25"
    [columns]="columns"
    [group]="group"
    [model]="model"
    (valueChangeByApiName)="onvalueChangeByApiName($event)">
  </form-control-model>
</div>
<kgrid
  *ngIf="filterInfo && filterInfo.length > 0 && HrmAccVoucherColimns && HrmAccVoucherColimns.length > 0"
  [apiName]="apiName"
  [label]="label"
  [name]="apiName"
  [areaName]="areaName"
  pathPreFix="HRM"
  [columns]="HrmAccVoucherColimns"
  [isMulti]="true"
  [isAdd]="false"
  [isEdit]="false"
  [isDelete]="false"
  [SelectById]="'HrmPersonnelId'"
  defaultSortKey="PersCode"
  aggregatesColumnName="Debit,Credit"
  defaultSortKeyKind="asc"
  [defaultFilterKey]="filterInfo"
  [actionTregger]="onActionClick"
  [actions]="actions">
</kgrid>
</div>

